import Vue from 'vue';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/element-ui-override.scss';
import i18n from '@/plugins/vue-i18n';

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
});
